import React from "react";
import "./AlignToolsWidget.css";
import PlanSelectionFlag from "./PlanSelectionFlag";
import OsteotomyHistory from "./sidebarHistoryComponents/osteotomyHistory/OsteotomyHistory";
import CageHistory from "./sidebarHistoryComponents/cageHistory/CageHistory";
import SpondyHistory from "./sidebarHistoryComponents/spondyHistory/SpondyHistory";
import GlobalAlignmentHistory from "./sidebarHistoryComponents/globalAlignmentHistory/GlobalAlignmentHistory";
import RodHistory from "./sidebarHistoryComponents/rodHistory/RodHistory";

const AlignToolsWidget = ({
  onDeleteSurgicalAct,
  onDeleteGlobalAlignment,
  onBulkDeleteSurgicalActs,
  onEditSurgicalAct,
  onEditAllRods,
  onEditGlobalAlignment,
  currentSurgicalActs,
  currentGlobalAlignment,
  comparedSurgicalActs,
  comparedGlobalAlignment,
  compareMode = false,
  currentPlanLabel = "Plan 1",
  comparedPlanLabel = "Plan 2",
  isPlanSelected,
  isSavingPlanSelection,
  onSelectPlan,
  planName,
  planSelectionDisabled = false,
}) => {
  return (
    <div className="App-widget-align">
      {onSelectPlan && (
        <PlanSelectionFlag
          isSelected={isPlanSelected}
          isSaving={isSavingPlanSelection}
          onSelectPlan={onSelectPlan}
          planName={planName}
          disabled={planSelectionDisabled}
        />
      )}
      <GlobalAlignmentHistory
        onDeleteGlobalAlignment={onDeleteGlobalAlignment}
        currentGlobalAlignment={currentGlobalAlignment}
        onEditGlobalAlignment={onEditGlobalAlignment}
        comparedGlobalAlignment={comparedGlobalAlignment}
        compareMode={compareMode}
        currentPlanLabel={currentPlanLabel}
        comparedPlanLabel={comparedPlanLabel}
      />
      <OsteotomyHistory
        onDeleteSurgicalAct={onDeleteSurgicalAct}
        currentSurgicalActs={currentSurgicalActs}
        onBulkDeleteSurgicalActs={onBulkDeleteSurgicalActs}
        onEditSurgicalAct={onEditSurgicalAct}
        comparedSurgicalActs={comparedSurgicalActs}
        compareMode={compareMode}
        currentPlanLabel={currentPlanLabel}
        comparedPlanLabel={comparedPlanLabel}
      />
      <SpondyHistory
        onDeleteSurgicalAct={onDeleteSurgicalAct}
        currentSurgicalActs={currentSurgicalActs}
        onBulkDeleteSurgicalActs={onBulkDeleteSurgicalActs}
        onEditSurgicalAct={onEditSurgicalAct}
        comparedSurgicalActs={comparedSurgicalActs}
        compareMode={compareMode}
        currentPlanLabel={currentPlanLabel}
        comparedPlanLabel={comparedPlanLabel}
      />
      <CageHistory
        onDeleteSurgicalAct={onDeleteSurgicalAct}
        currentSurgicalActs={currentSurgicalActs}
        onBulkDeleteSurgicalActs={onBulkDeleteSurgicalActs}
        onEditSurgicalAct={onEditSurgicalAct}
        comparedSurgicalActs={comparedSurgicalActs}
        compareMode={compareMode}
        currentPlanLabel={currentPlanLabel}
        comparedPlanLabel={comparedPlanLabel}
      />
      <RodHistory
        onDeleteSurgicalAct={onDeleteSurgicalAct}
        currentSurgicalActs={currentSurgicalActs}
        onBulkDeleteSurgicalActs={onBulkDeleteSurgicalActs}
        onEditSurgicalAct={onEditSurgicalAct}
        onEditAllRods={onEditAllRods}
        comparedSurgicalActs={comparedSurgicalActs}
        compareMode={compareMode}
        currentPlanLabel={currentPlanLabel}
        comparedPlanLabel={comparedPlanLabel}
      />
    </div>
  );
};

export default AlignToolsWidget;
